import React, {Component} from 'react'
import {connect} from 'react-redux';
import ImagePreview from "components/Upload/ImagePreview";
import {Card} from "components/Card/Card.jsx";
import FileUpload from "components/Upload/FileUpload";
import SimpleReactValidator from 'simple-react-validator';
import {themeCSSConstants} from 'redux/constant/themeCSS';
import {withRouter} from 'react-router-dom';
import ToggleButton from "react-toggle-button";
import {helperFunctions as HF} from '../../../helper/helperFunctions';
import {
    Grid,
    Row,
    Col,
} from "react-bootstrap";
import {brandActions} from '../../../redux/actions/brand-actions';
import {s3Paths} from '../../../redux/constant/admin-label-constant';
import Contact from "../../ThemeComponents/Contact";
import User from "../../ThemeComponents/User";
import Address from "../../ThemeComponents/Address";
import {listActions} from "../../../redux/actions/list-actions";
import {objectsConstants as OC} from "../../../redux/constant/objects-constant";

class AddBrand extends Component {
    constructor(props) {
        super(props);
        this.validatorBrand = new SimpleReactValidator();
        this.state = {
            brand: {
                brand_data: {
                    title: '',
                    short_code: '',
                    brand_status: '',
                    requiredTagFlag: true,
                    submitted: false,
                    allowedFormatsStringMime: 'image/jpeg, image/png',
                    allowedFormatsStringExt: 'jpg, png',
                    fileUploaded: false,
                },
                contact: {
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone: "",
                    type_id: "",
                },
                user: {
                    user_name: "",
                    password: "",
                    password_confirmation: ""
                },
                address: {
                    contact_name: "",
                    line1: "",
                    country_id: "",
                    city: "",
                    region_id: "",
                    zip_post_code: ""
                }
            },
            showBrandInfo: false
        }
        this.props.getListCall('country', "", "", "", "", "country", false);

    }


    componentDidMount() {
        if (this.props.location.state) {
            if (this.props.location.state.type === 'edit') {
                let logoUrl = null;
                if (this.props.location.state.brandData.logo) {
                    logoUrl = s3Paths.s3_main_url + this.props.location.state.brandData.logo;
                }
                let requiredTagFlag;
                
                this.setState({
                    brand: {
                        ...this.state.brand,
                        brand_data: {
                            title: this.props.location.state ? this.props.location.state.brandData.title : '',
                            short_code: this.props.location.state ? this.props.location.state.brandData.short_code : '',
                            brand_status: this.props.location.state ? !!this.props.location.state.brandData.status : false,
                            requiredTagFlag : this.props.location.state ? !!this.props.location.state.brandData.status : false,
                            logo: logoUrl,
                        },
                        contact: {
                            ...this.props.location.state.brandData.contact
                        },
                        address: {
                            ...this.props.location.state.brandData.address
                        },
                        user: {
                            ...this.props.location.state.brandData.user,
                            password: '' //! added because password field isn't sent from backend and that creates an error
                        },
                    },
                    showBrandInfo: true
                })
            }           
        } else {
            this.setState({
                showBrandInfo: true
            })
        }
    }


    onChange = (e) => {
        this.setState({
            brand: {
                ...this.state.brand,
                brand_data: {...this.state.brand.brand_data, [e.target.name]: e.target.value}
            },
        })
    }


    extractImageData = (value) => {
        const file = {};
        file['file'] = value['file'];
        file['name'] = value['name'];
        file['size'] = value['size'];
        file['extension'] = HF.returnExtFromImage(value['name']);
        file['preview'] = value['preview'];
        file['type'] = value['type'];
        file['lastModified'] = value['lastModified'];
        return file;
    }

    setResourceFile = (key, value) => {
        this.setState({
            brand: {
                ...this.state.brand,
                brand_data: {...this.state.brand.brand_data, logo: value, fileUploaded: true,}
            },
        });
    }

    removeFile = (key, index) => {
        this.setState({
            brand: {
                ...this.state.brand,
                brand_data: {...this.state.brand.brand_data, logo: null}
            },
        });
    }

    changeFlag = (toggle) => {
        this.setState({
            brand: {
                ...this.state.brand,
                brand_data: {
                    ...this.state.brand.brand_data,
                    requiredTagFlag: !toggle,
                    brand_status: !toggle
                }
            },
        });
    }

    getStateContact = state => {
        this.setState(prevState => ({
            brand: {
                ...prevState.brand,
                contact: {
                    ...state.contact
                }
            }
        }));
    };

    getStateUser = state => {
        this.setState(prevState => ({
            brand: {
                ...prevState.brand,
                user: {
                    ...state.user
                }
            }
        }));
    };

    getState = state => {
        this.setState(prevState => ({
            brand: {
                ...prevState.brand,
                ...state
            }
        }));
    };


    getUserProps = () => {
        if (this.state.formType === "edit") {
            return this.state.brand;
        } else {
            return this.state.brand;
        }
    };


    onBrandSubmit = (e) => {
        e.preventDefault();
        if (this.validatorBrand.allValid()) {
            const fd = new FormData();
            fd.append('title', this.state.brand.brand_data.title);
            fd.append('short_code', this.state.brand.brand_data.short_code);
            fd.append('brand_status', +this.state.brand.brand_data.brand_status);
            fd.append('address', JSON.stringify({...this.state.brand.address}));
            fd.append('contact', JSON.stringify({...this.state.brand.contact}));
            fd.append('user', JSON.stringify({...this.state.brand.user}));

            if (this.state.brand.brand_data.fileUploaded) {
                fd.append('logo', this.state.brand.brand_data.logo);
            }
            //Make the put call into post and add _method put because its form Data
            if (this.props.location.state) {
                if (this.props.location.state.type === 'edit') {
                    fd.append('_method', 'put')
                    this.props.updateBrandCall(this.props.match.params.brandId, fd).then(res => {
                        this.props.history.push(`/Admin/brands-list`)
                    })
                }
                return
            }
            this.props.storeBrandCall(fd).then(res => {
                this.props.history.push(`/Admin/brands-list`)
                this.props.brandHandler(res.result.brand);
            })
            this.setState({
                submitted: true
            });
        } else {
            this.setState({submitted: false});
            this.validatorBrand.showMessages();
            this.forceUpdate();
        }
    }


    render() {
        const {title, short_code} = this.state.brand.brand_data;
        const {allowedFormatsStringMime, allowedFormatsStringExt, requiredTagFlag} = this.state.brand.brand_data;

        return (<Grid fluid>
            <Row>
                <Col md={12}>
                    <Card
                        ctTableResponsive
                        content={
                            <div>
                                <Grid fluid>
                                    <Row>
                                        <Col md={12}>
                                            <h3 style={{
                                                textAlign: 'center',
                                                fontWeight: "500"
                                            }}>{this.props.location.state ? 'Edit Brand' : 'Add New Brand'}</h3>
                                            <form onSubmit={this.onBrandSubmit}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className='form-group' style={{marginTop: "26px"}}>
                                                            <div className="flexElem fieldWithLabel alignFlexCenter">
                                                                <div>
                                                                    <label htmlFor="title">Title<span
                                                                        className="requiredClass">*</span></label>
                                                                </div>
                                                                <div>
                                                                    <input type="text" name="title"
                                                                           className="form-control" value={title}
                                                                           onChange={this.onChange}/>
                                                                    {this.validatorBrand.message('title', title, 'required|min:3')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-group'>
                                                            <div className="flexElem fieldWithLabel alignFlexCenter">
                                                                <div>
                                                                    <label htmlFor="short_code">Short Code<span
                                                                        className="requiredClass">*</span></label>
                                                                </div>
                                                                <div>
                                                                    <input type="text" name="short_code"
                                                                           className="form-control" value={short_code}
                                                                           onChange={this.onChange}
                                                                           disabled={this.props.location.state ? true : false}/>
                                                                    {this.validatorBrand.message('short_code', short_code, 'required|min:3')}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-group'>
                                                            <div className="flexElem fieldWithLabel alignFlexCenter">
                                                                <div>
                                                                    <label>Status</label>
                                                                </div>

                                                                <div>
                                                                    <ToggleButton
                                                                        inactiveLabel={''}
                                                                        activeLabel={''}
                                                                        colors={themeCSSConstants.THUMBICONSTYLE}
                                                                        trackStyle={themeCSSConstants.TRACKSTYLE}
                                                                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                                                                        thumbAnimateRange={[4, 30]}
                                                                        value={requiredTagFlag}
                                                                        onToggle={() => this.changeFlag(requiredTagFlag)}
                                                                        name="requiredTagFlag"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="col-md-6 addBrand pofilePicContainer">
                                                        {!this.state.brand.brand_data.logo
                                                            ?
                                                            <div className='form-group dropzone_profileImage'>
                                                                <FileUpload
                                                                    files={this.state.brand.brand_data.logo}
                                                                    setResourceFile={this.setResourceFile}
                                                                    allowedFormatsStringMimePro={allowedFormatsStringMime}
                                                                    allowedFormatsStringExtPro={allowedFormatsStringExt}
                                                                    multiple={false}
                                                                />
                                                            </div>
                                                            :
                                                            <ImagePreview
                                                                filesToPreview={this.state.brand.brand_data.logo}
                                                                removeFile={this.removeFile}
                                                                addBrand={true}
                                                            />
                                                        }
                                                    </div>

                                                </div>
                                                {(this.state.showBrandInfo) &&

                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <h4 style={{
                                                            fontWeight: "500"
                                                        }}>Primary Contact </h4>
                                                        <div className="flexElem addCustomer">
                                                            <Contact
                                                                contactObject={this.state.brand}
                                                                contactProp={this.state.brand}
                                                                requiredField={{
                                                                    first_name: "required",
                                                                    last_name: "required",
                                                                    email: "required"
                                                                }}
                                                                shippingAddress={false}
                                                                htmlElement={"contact"}
                                                                returnState={this.getStateContact}
                                                                validatorInstance={
                                                                    this.validatorBrand
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="">
                                                            <h4 style={{
                                                                fontWeight: "500"
                                                            }}>User</h4>
                                                            <User
                                                                requiredField={{
                                                                    user_name: "required",
                                                                    password: "required",
                                                                    password_confirmation: "required"
                                                                }}
                                                                htmlElement={"user"}
                                                                returnState={this.getStateUser}
                                                                validatorInstance={
                                                                    this.validatorBrand
                                                                }
                                                                contactProp={this.state.brand}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <h4 style={{
                                                            fontWeight: "500", marginBottom: '0'
                                                        }}>Primary Address </h4>
                                                        <Address
                                                            addressObject={
                                                                this.state.brand.address || OC.ADDRESS
                                                            }
                                                            formTypePro={this.props.location.state ? "edit" : ''}
                                                            htmlElement={"Address "}
                                                            shippingAddress={false}
                                                            options={{
                                                                countries: this.props.countries
                                                            }}
                                                            requiredField={{
                                                                contact_name: "required",
                                                                line1: "required",
                                                                country_id: "required",
                                                                city: "required",
                                                                region_id: "required",
                                                                zip_post_code: ""
                                                                    ? ["integer", "required"]
                                                                    : ["integer"],
                                                                phone: "required",
                                                                email: "required"
                                                            }}
                                                            countries={this.props.country}
                                                            returnState={this.getState}
                                                            validatorInstance={this.validatorBrand}
                                                        />
                                                    </div>


                                                </div>
                                                }
                                                <div style={{textAlign: 'center'}}>
                                                    <button className="customBtn btnBlack mt-lg"
                                                            type="submit"
                                                    >
                                                        {this.props.location.state ? 'Save Updates' : 'Add Brand'}
                                                    </button>
                                                </div>
                                            </form>
                                        </Col>
                                    </Row>
                                </Grid>

                            </div>
                        }
                    />
                </Col>
            </Row>
        </Grid>)
    }

}

const mapDispatchToProps = dispatch => {
    return ({
        storeBrandCall: (brandData) => {
            return dispatch(brandActions.storeBrand(brandData))
        },
        getListCall: (
            id,
            page,
            filter,
            sort,
            pageSize,
            component_name,
            pagination
        ) => {
            dispatch(
                listActions.getList(
                    id,
                    page,
                    filter,
                    sort,
                    pageSize,
                    component_name,
                    pagination
                )
            );
        },
        updateBrandCall: (id, brandData) => {
            return dispatch(brandActions.updateBrand(id, brandData))
        },
    })
        ;
};

function mapStateToProps(state) {
    const {brand} = state.brandReducer;
    const {country} = state.listReducer;
    return {
        brand,
        country
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddBrand));



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/AddBrand.jsx